import axios from 'axios';
import { getCreatorToken } from './sessionStorage';

const API_URL = process.env.REACT_APP_API_URL || '';

const apiClient = axios.create({
  baseURL: `${API_URL}/creator-portal`,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const token = getCreatorToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config._creatorToken = token;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.config?.url !== '/auth/exchange') {
      window.dispatchEvent(new CustomEvent('creator-auth:unauthorized', {
        detail: {
          code: error.response?.data?.code,
          url: error.config?.url,
          token: error.config?._creatorToken
        }
      }));
    }
    return Promise.reject(error);
  }
);

export default apiClient;
